  // =====================================================
  // PIN DATA — coords are in the map's SVG viewBox space (1278 × 766).
  // type ∈ { 'product' | 'facility' | 'trial' }  → matches legend icons.
  // Tweak x / y here to reposition pins; they scale with the map.
  // =====================================================
  const pins = [
    { x: 640, y: 480, type: 'product',  label: 'Melbourne hub',       country: 'australia'  },
    { x: 690, y: 480, type: 'trial',  label: 'Hobart distribution', country: 'australia'  },
    { x: 970, y: 620, type: 'product',    label: 'South Island trial',  country: 'newZealand' }
  ];

    // =====================================================
  // ICON DEFINITIONS — each icon lives in its own SVG file under
  // assets/icons/ so you can edit them independently.
  // Mapping: symbol id → file path
  // =====================================================
  let ICON_FILES = {};

  const SVG_NS = 'http://www.w3.org/2000/svg';
  const XLINK_NS = 'http://www.w3.org/1999/xlink';

  // =====================================================
  // MAP LOADER — fetch map.svg (via Shopify asset URL), inject inline so JS can
  // query and manipulate the SVG DOM (region clicks, pin rendering).
  // =====================================================
  async function loadMap() {
    const canvas = document.getElementById('mapCanvas');
    const svgUrl = canvas.dataset.svgUrl || 'assets/map.svg';

    ICON_FILES = {
      'pin-icon-product':  canvas.dataset.iconProductUrl || './icon-product.svg',
      'pin-icon-trial':    canvas.dataset.iconTrialUrl || './icon-trial.svg',
    };
    
    // Load JSON data from liquid
    const mapDataEl = document.querySelector('script[type="application/json"][data-map-regions]');
    if (mapDataEl) {
      window.countries = JSON.parse(mapDataEl.textContent);
    } else {
      window.countries = {}; // Fallback
    }

    const res = await fetch(svgUrl);
    const text = await res.text();
    canvas.innerHTML = text;

    const mapSvg = canvas.querySelector('svg');
    if (!mapSvg) return;

    // Ensure a <defs> element exists to hold our symbols
    let defs = mapSvg.querySelector('defs');
    if (!defs) {
      defs = document.createElementNS(SVG_NS, 'defs');
      mapSvg.insertBefore(defs, mapSvg.firstChild);
    }

    // Fetch each icon and inject it as a named <symbol>
    await Promise.all(
      Object.entries(ICON_FILES).map(async ([symbolId, filePath]) => {
        const iconRes  = await fetch(filePath);
        const iconText = await iconRes.text();

        // Parse the fetched SVG string
        const parser  = new DOMParser();
        const iconDoc = parser.parseFromString(iconText, 'image/svg+xml');
        const iconSvg = iconDoc.querySelector('svg');
        if (!iconSvg) return;

        // Build a <symbol> mirroring the source SVG's viewBox
        const symbol = document.createElementNS(SVG_NS, 'symbol');
        symbol.setAttribute('id', symbolId);
        symbol.setAttribute('viewBox', iconSvg.getAttribute('viewBox') || '0 0 100 100');

        // Move all children from the icon SVG into the symbol,
        // but hoist <defs> contents directly into the main map's <defs>
        // so that gradients/masks can be referenced correctly by SVG elements.
        Array.from(iconSvg.childNodes).forEach(node => {
          if (node.nodeName && node.nodeName.toLowerCase() === 'defs') {
            Array.from(node.childNodes).forEach(defChild => {
              defs.appendChild(document.importNode(defChild, true));
            });
          } else {
            symbol.appendChild(document.importNode(node, true));
          }
        });

        defs.appendChild(symbol);
      })
    );
  }

  // =====================================================
  // RENDER PINS — build <g class="pin"> elements once, on init.
  // =====================================================
  const PIN_RADIUS = 16;  // circle radius in viewBox units
  const ICON_SIZE  = 20;  // icon side length, centered in circle

  function renderPins() {
    const layer = document.getElementById('mapPins');
    if (!layer) return;
    layer.innerHTML = '';

    pins.forEach(pin => {
      const g = document.createElementNS(SVG_NS, 'g');
      g.setAttribute('class', 'pin');
      g.setAttribute('transform', `translate(${pin.x}, ${pin.y})`);
      g.setAttribute('data-pin-type', pin.type);
      g.setAttribute('data-pin-country', pin.country);

      // Title for native browser tooltip + accessibility
      const title = document.createElementNS(SVG_NS, 'title');
      title.textContent = pin.label;
      g.appendChild(title);

      // White background circle with navy stroke
      const circle = document.createElementNS(SVG_NS, 'circle');
      circle.setAttribute('class', 'pin-bg');
      circle.setAttribute('cx', 0);
      circle.setAttribute('cy', 0);
      circle.setAttribute('r', PIN_RADIUS);
      g.appendChild(circle);

      // Icon — <use> references one of the <symbol> defs in the SVG
      const use = document.createElementNS(SVG_NS, 'use');
      use.setAttribute('class', 'pin-icon');
      use.setAttribute('href', `#pin-icon-${pin.type}`);
      // xlink fallback for older renderers
      use.setAttributeNS(XLINK_NS, 'xlink:href', `#pin-icon-${pin.type}`);
      use.setAttribute('x', -ICON_SIZE / 2);
      use.setAttribute('y', -ICON_SIZE / 2);
      use.setAttribute('width', ICON_SIZE);
      use.setAttribute('height', ICON_SIZE);
      g.appendChild(use);

      layer.appendChild(g);
    });
  }

  // =====================================================
  // RENDER — given a region key, paint the panel + map state.
  // =====================================================
  const panel       = document.getElementById('infoPanel');
  const nameEl      = document.getElementById('infoName');
  const paragraphEl = document.getElementById('infoParagraphs');
  const addressEl   = document.getElementById('infoAddress');

  function render(regionKey) {
    const data = window.countries[regionKey];
    if (!data) return;

    // Brief fade so the swap reads as a transition, not a jump
    panel.classList.add('is-swapping');

    window.requestAnimationFrame(() => {
      // Country name
      nameEl.textContent = data.name;

      // Paragraphs (HTML from Rich Text block)
      paragraphEl.innerHTML = data.paragraphs || '';

      // Contact block (HTML from Rich Text block)
      addressEl.innerHTML = data.contact || '';

      // Map active state
      document.querySelectorAll('.region').forEach(el => {
        el.classList.toggle('is-active', el.dataset.region === regionKey);
        el.setAttribute('aria-pressed', el.dataset.region === regionKey ? 'true' : 'false');
      });

      // Release fade on next tick so transition runs
      setTimeout(() => panel.classList.remove('is-swapping'), 20);
    });
  }

  // =====================================================
  // INIT — load map, then wire up interactivity.
  // =====================================================
  loadMap().then(() => {
    // Attach region click / keyboard listeners (elements now exist in DOM)
    document.querySelectorAll('.region').forEach(el => {
      el.addEventListener('click', () => render(el.dataset.region));
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          render(el.dataset.region);
        }
      });
    });

    renderPins();
    render('australia');
  });